import React, { useState } from 'react';
import { callJamboProxy } from '../../utils/tianlanStore';

function JamboCommodityPicker({ shop, title = '搜尋直播商品', onPick, pickedIds = [] }) {
  const [keyword, setKeyword] = useState('');
  const [searchCondition, setSearchCondition] = useState('part_number');
  const [shelf, setShelf] = useState('all');
  const [results, setResults] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pickingId, setPickingId] = useState('');

  const search = async () => {
    if (!keyword.trim()) {
      alert('請輸入料號或品名');
      return;
    }
    setIsLoading(true);
    try {
      const data = await callJamboProxy('searchCommodityBarcode', {
        keyword: keyword.trim(),
        searchCondition,
        shelf,
        limit: 30,
      }, shop);
      setResults(data.results || (data.commodity ? [data.commodity] : []));
    } catch (error) {
      alert(`搜尋直播商品失敗：${error.message}`);
    }
    setIsLoading(false);
  };

  const pick = async (commodity) => {
    const id = String(commodity.commodityId || commodity.id || '');
    if (!id) return;
    setPickingId(id);
    try {
      const detail = await callJamboProxy('loadCommodityById', { commodityId: id }, shop);
      onPick?.(detail.commodity || commodity);
    } catch (_) {
      onPick?.(commodity);
    } finally {
      setPickingId('');
    }
  };

  return (
    <div className="tl-panel tl-panel-pad">
      <div className="tl-panel-head">
        <div>
          <div className="tl-panel-title">{title}</div>
          <div className="tl-panel-desc">直接讀目前商店的商品資料；名稱、圖片、樣式、價格都不用手填。</div>
        </div>
      </div>
      <div className="tl-form-row" style={{ marginBottom: 14 }}>
        <select className="modern-input tl-search-mode" value={searchCondition} onChange={(e) => setSearchCondition(e.target.value)}>
          <option value="part_number">料號</option>
          <option value="name">品名</option>
        </select>
        <select className="modern-input tl-search-shelf" value={shelf} onChange={(e) => setShelf(e.target.value)}>
          <option value="all">全部商品</option>
          <option value="normal">一般商品</option>
          <option value="combined">組合商品</option>
        </select>
        <input
          className="modern-input tl-search-input"
          value={keyword}
          onChange={(e) => setKeyword(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && search()}
          placeholder={searchCondition === 'part_number' ? '輸入商品料號' : '輸入商品名稱'}
        />
        <button className="modern-btn modern-btn-primary" onClick={search} disabled={isLoading}>
          {isLoading ? '搜尋中...' : '搜尋'}
        </button>
      </div>

      <div className="tl-commodity-grid">
        {results.map((commodity) => {
          const id = String(commodity.commodityId || commodity.id);
          const picked = pickedIds.map(String).includes(id);
          return (
            <button
              key={id}
              type="button"
              onClick={() => pick(commodity)}
              disabled={Boolean(pickingId)}
              className={`tl-commodity-card ${picked ? 'is-picked' : ''}`}
            >
              <div className="tl-commodity-media-row">
                {commodity.image ? (
                  <img src={commodity.image} alt={commodity.name} className="tl-commodity-image" />
                ) : (
                  <div className="tl-commodity-placeholder">無圖</div>
                )}
                <div>
                  <div className="tl-commodity-name">{commodity.name || '未命名商品'}</div>
                  {commodity.combined === true && (
                    <div className="tl-combined-badge">組合商品・{commodity.subCommodities?.length || 0} 項子商品</div>
                  )}
                  <div className="tl-commodity-meta">料號：{commodity.partNumber || '-'}</div>
                  <div className="tl-commodity-meta">ID：{id} / ${commodity.price || 0}</div>
                </div>
              </div>
              <div className="tl-commodity-meta" style={{ marginTop: 8 }}>
                樣式：{commodity.styles?.length > 0
                  ? `${commodity.styles.slice(0, 4).join('、')}${commodity.styles.length > 4 ? '...' : ''}`
                  : '無樣式商品'}
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default JamboCommodityPicker;
